import { React, useState } from 'react';
import { Button, FormLabel, Radio, Stack, RadioGroup, Textarea } from '@chakra-ui/react'
import { Formik, Form } from 'formik';
import ModalInformation from './ModalInformation';
import { useNavigate } from 'react-router-dom';
import sm1 from '../assetss/img/smiley1.png'
import sm2 from '../assetss/img/smiley2.png'
import sm3 from '../assetss/img/smiley3.png'
import sm4 from '../assetss/img/smiley4.png'
import sm5 from '../assetss/img/smiley5.png'
import ApiService from "./ApiService";
import loading from '../assetss/img/loading64.gif'



const Body = ({ setPageMessage, codigo, turno_id }) => {
    const [valueodo, setValueOdo] = useState('0');
    const [valuerec, setValueRec] = useState('0');
    const [valueres, setValueRes] = useState('0');
    const [valuecom, setValueCom] = useState('');
    const [modalMessage, setModalMessage] = useState(null);
    const [modalInformationOpen, setModalInformationOpen] = useState(false);
    const [Loading, setLoading] = useState(false);

    //const navigate = useNavigate();
    //const GoToHomePage = () => navigate('/');


    const submitForm = (data) => {
        if (valueodo === '0' || valuerec === '0' || valueres === '0') {
            setModalMessage("Por favor marque todas las opciones.");
            setModalInformationOpen(true);
        } else {
            console.log(valueodo)
            console.log(valuerec)
            console.log(valueres)
            console.log(valuecom)
            saveEncuesta();
        }
    };

    async function saveEncuesta() {
        setLoading(true);
        let comentario = valuecom;
        comentario = comentario.replace(/#/g, " ");
        comentario = comentario.replace(/&/g, " ");
        comentario = comentario.replace(/</g, " ");
        comentario = comentario.replace(/>/g, " ");
        let params = "co=" + codigo + "&ti=" + turno_id + "&pregunta[1]=1&respuesta[1]=" + valueodo + "&pregunta[2]=2&respuesta[2]=" + valuerec + "&pregunta[3]=3&respuesta[3]=" + valueres + "&pregunta[4]=4&respuesta[4]=" + comentario;
        let result = await ApiService.SaveEncuesta("encuesta-respuesta/responder", params);
        console.log(result);
        if (result.error === true) {
            setLoading(false);
            setPageMessage(result.errormessage);
        } else {
            setLoading(false);
            setPageMessage("Muchas Gracias por ayudarnos a mejorar !!!");
        }
        return;
    }

    const handleCommentChange = (e) => {
        const inputValue = e.target.value
        setValueCom(inputValue)
    }
    const hideInformationModal = () => {
        setModalMessage(null);
        setModalInformationOpen(false);
    };

    return (

        <div >
            <Formik
                initialValues={{
                    opt_odo: "0",
                    opt_rec: '0',
                    opt_res: '0',
                }}
                onSubmit={values => {
                    submitForm(values);
                }}
            >
                {formik => (
                    <Form onSubmit={formik.handleSubmit}>
                        <div className='sm:grid grid-cols-12 '>
                            <div className="sm:col-start-4 col-span-8 ">
                                <div>
                                    <p className='font-overpass fontsize text-2xl font-normal text-slate-500 mt-5 mb-5 ml-5 mr-5'>
                                        Estimado Paciente,<br />
                                        Como parte de un proceso de mejora continua en la calidad de atención,<br />
                                        le solicitamos que por favor se tome un breve momento para darnos su valoración.<br />
                                        Muchas gracias!
                                    </p>
                                </div>
                                <div className="flex justify-start text-2xl text-slate-500 font-overpass font-normal">
                                    <FormLabel fontSize={window.innerWidth > 640 ? "2xl" : "2xl"} as='i' htmlFor='atencion_odo' ml='5' mb='5'>
                                        Como evalúa la atención del odontólogo(a) ?
                                    </FormLabel>
                                </div>
                                <div className="flex justify-start">
                                    <RadioGroup name="opt_odo" className="flex items-start ml-5 text-sky-800 font-overpass font-normal" onChange={setValueOdo} value={valueodo}>
                                        <Stack spacing={5} direction={window.innerWidth > 640 ? "row" : "column"}>
                                            <div className='flex justify-start align-middle'>
                                                <Radio className='mr-1' size='lg' value='5'  borderColor="gray.600"></Radio>
                                                <img className='h-12 w-12' alt="5" src={sm5} />
                                            </div>
                                            <div className='flex justify-start align-middle'>
                                                <Radio className='mr-1' size='lg' value='4' borderColor="gray.600"></Radio>
                                                <img className='h-12 w-12' alt="4" src={sm4} />
                                            </div>
                                            <div className='flex justify-start align-middle'>
                                                <Radio className='mr-1' size='lg' value='3' borderColor="gray.600"></Radio>
                                                <img className='h-12 w-12' alt="3" src={sm3} />
                                            </div>
                                            <div className='flex justify-start align-middle'>
                                                <Radio className='mr-1' size='lg' value='2' borderColor="gray.600"></Radio>
                                                <img className='h-12 w-12' alt="2" src={sm2} />
                                            </div>
                                            <div className='flex justify-start align-middle'>
                                                <Radio className='mr-1' size='lg' value='1' borderColor="gray.600"></Radio>
                                                <img className='h-12 w-12' alt="1" src={sm1} />
                                            </div>
                                        </Stack>
                                    </RadioGroup>
                                </div>
                                <div className="flex justify-start text-2xl text-slate-500 font-overpass font-normal">
                                    <FormLabel fontSize={window.innerWidth > 640 ? "2xl" : "2xl"} as='i' htmlFor='atencion_sec' mt='10' ml='5' mb='5'>
                                        Como evalúa la atención de el/la recepcionista ?
                                    </FormLabel>
                                </div>
                                <div className="flex justify-start">
                                    <RadioGroup id="opt_rec" name="opt_rec" className="items-start ml-5  text-sky-800 font-overpass font-normal" onChange={setValueRec} value={valuerec}>
                                        <Stack spacing={5} direction={window.innerWidth > 640 ? "row" : "column"}>
                                            <div className='flex justify-start align-middle'>
                                                <Radio className='mr-1' size='lg' value='5' borderColor="gray.600"></Radio>
                                                <img className='h-12 w-12' alt="5" src={sm5} />
                                            </div>
                                            <div className='flex justify-start align-middle'>
                                                <Radio className='mr-1' size='lg' value='4' borderColor="gray.600"></Radio>
                                                <img className='h-12 w-12' alt="4" src={sm4} />
                                            </div>
                                            <div className='flex justify-start align-middle'>
                                                <Radio className='mr-1' size='lg' value='3' borderColor="gray.600"></Radio>
                                                <img className='h-12 w-12' alt="3" src={sm3} />
                                            </div>
                                            <div className='flex justify-start align-middle'>
                                                <Radio className='mr-1' size='lg' value='2' borderColor="gray.600"></Radio>
                                                <img className='h-12 w-12' alt="2" src={sm2} />
                                            </div>
                                            <div className='flex justify-start align-middle'>
                                                <Radio className='mr-1' size='lg' value='1' borderColor="gray.600"></Radio>
                                                <img className='h-12 w-12' alt="1" src={sm1} />
                                            </div>
                                        </Stack>
                                    </RadioGroup>
                                </div>
                                <div className="flex justify-start text-2xl text-slate-500 font-overpass font-normal">
                                    <FormLabel fontSize={window.innerWidth > 640 ? "2xl" : "2xl"} as='i' htmlFor='resuelto' mt='10' ml='5' mb='5'>
                                        Cómo evalúa la resolución del motivo de su visita?
                                    </FormLabel>
                                </div>
                                <div className="flex justify-start">
                                    <RadioGroup name="opt_res" className="flex justify-center items-start ml-5  text-sky-800 font-overpass font-normal" onChange={setValueRes} value={valueres}>
                                        <Stack spacing={5} direction={window.innerWidth > 640 ? "row" : "column"}>
                                            <div className='flex justify-start align-middle'>
                                                <Radio className='mr-1' size='lg' value='5' borderColor="gray.600"></Radio>
                                                <img className='h-12 w-12' alt="5" src={sm5} />
                                            </div>
                                            <div className='flex justify-start align-middle'>
                                                <Radio className='mr-1' size='lg' value='4' borderColor="gray.600"></Radio>
                                                <img className='h-12 w-12' alt="4" src={sm4} />
                                            </div>
                                            <div className='flex justify-start align-middle'>
                                                <Radio className='mr-1' size='lg' value='3' borderColor="gray.600"></Radio>
                                                <img className='h-12 w-12' alt="3" src={sm3} />
                                            </div>
                                            <div className='flex justify-start align-middle'>
                                                <Radio className='mr-1' size='lg' value='2' borderColor="gray.600"></Radio>
                                                <img className='h-12 w-12' alt="2" src={sm2} />
                                            </div>
                                            <div className='flex justify-start align-middle'>
                                                <Radio className='mr-1' size='lg' value='1' borderColor="gray.600"></Radio>
                                                <img className='h-12 w-12' alt="1" src={sm1} />
                                            </div>
                                        </Stack>
                                    </RadioGroup>
                                </div>
                                <div className="flex justify-start text-2xl text-slate-500 font-overpass font-normal">
                                    <FormLabel fontSize={window.innerWidth > 640 ? "2xl" : "2xl"} as='i' htmlFor='comentario' mt='10' ml='5' mb='5'>
                                        Desea agregar algún comentario o sugerencia:
                                    </FormLabel>
                                </div>
                                <div className="flex ml-5 justify-start items-center">
                                    <div>
                                        <Textarea
                                            style={window.innerWidth > 640 ? { width: 720, height: 200 } : { width: 320, height: 400 }}
                                            value={valuecom}
                                            onChange={handleCommentChange}
                                            placeholder=''
                                            size='lg'
                                            borderColor="gray.600"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex justify-center items-center mt-5 mb-5">
                        {
                                (Loading) &&
                                <div>{(Loading) && <img alt="Loading" src={loading} />}</div>
                            }

                        </div>
                        <div className="flex justify-center items-center mt-10 h-16 border-t-2 border-b-2  border-[#3F8CCB] font-overpass font-normal" >
                            <Button type="submit" style={{ width: 250, height: 40 }} colorScheme='blue' variant='solid' ml='5' mt='5' mb='5' onClick={null} >
                                Enviar
                            </Button>
                        </div>
                    </Form>
                )}
            </Formik>
            <div>
                <ModalInformation showModal={modalInformationOpen && modalMessage !== null} hideModal={hideInformationModal} message={modalMessage} />
            </div>
        </div>
    )
}
export default Body;
